import React from 'react';
import { BrowserRouter as Router, Routes, Route  } from 'react-router-dom';
import './App.css';
import LoginForm from './pages/LoginForm';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import Dashboard from './pages/Dashboard';
import Main from './pages/Main';
import Reports from './pages/Reports';
import ReportView from './pages/ReportView';
import ModuleReportView from './pages/Reports/ModuleView';
import Surveyor from './Surveyor';
import 'react-toastify/dist/ReactToastify.css';
import PrivateRoute from './pages/PrivateRoute';
import PublicRoute from './pages/PublicRoute';
import Test from './pages/Test';
import ZoneWiseReport from './pages/ZoneWiseReport';
import ModuleReports from './pages/Reports/moduleReports';
import GroupedReports from './pages/GroupedReports';
import ReportViewGroup from './pages/ReportViewGroup';
import ReportEdit from './pages/ReportEdit';
import ApprovalPendingReports from './pages/Reports/approvalpendingreports/WaitingForApprovalReport';
import Category from './pages/Masters/category/Category';
import SubCategory from './pages/Masters/subcategory/SubCategory';
import WaitingForApprovalEdit from './pages/Reports/approvalpendingreports/WaitingForApprovalEdit';
import VerifiedDeletedReport from './pages/Reports/deletedreports/VerifiedDeletedReport';
import UnverifiedDeletedReport from './pages/Reports/deletedreports/UnverifiedDeletedReport';
import UnVerifiedReportAddForm from './pages/Reports/unverifiedreports/UnVerifiedReportAddForm';
import EditVerifiedReportForm from './pages/Reports/verifiedreports/EditVerifiedReportForm';
import WaitingForApprovalDeletedReport from './pages/Reports/deletedreports/WaitingForApprovalDeletedReport';

function App() {
  
  return (
    <>
     {/* <Main /> */}
      <Router>
      <ToastContainer />
        <Routes>
            <Route path="/" element={<PublicRoute><LoginForm /></PublicRoute>} />
            <Route path="/dashboard" element={<PrivateRoute><Main element={Dashboard}/></PrivateRoute>} />
            <Route path="/reports" element={<PrivateRoute><Main element={Reports}/></PrivateRoute>}/>
            <Route path="/module_reports" element={<PrivateRoute><Main element={ModuleReports}/></PrivateRoute>}/>
            <Route path="/verified-deleted-report" element={<PrivateRoute><Main element={VerifiedDeletedReport}/></PrivateRoute>}/>
            <Route path="/waiting-for-apporval-deleted-report" element={<PrivateRoute><Main element={WaitingForApprovalDeletedReport}/></PrivateRoute>}/>
            <Route path="/edit-verified-form/:id" element={<PrivateRoute><Main element={EditVerifiedReportForm}/></PrivateRoute>}/>
            <Route path="/unverified-deleted-report" element={<PrivateRoute><Main element={UnverifiedDeletedReport}/></PrivateRoute>}/>
            <Route path="/surveyor" element={<PrivateRoute><Main element={Surveyor}/></PrivateRoute>}/>
            <Route path="reports-view/:id1?/:id2?" element={<PrivateRoute><Main element={ReportView}/></PrivateRoute>}/>
            <Route path="/unverified-report-add-form" element={<PrivateRoute><Main element={UnVerifiedReportAddForm}/></PrivateRoute>}/>
            <Route path="module-reports-view/:id1?/:id2?" element={<PrivateRoute><Main element={ModuleReportView}/></PrivateRoute>}/>
            {/* <Route path="/loginForm" element={<PrivateRoute><Main element={LoginForm}/></PrivateRoute>}/> */}
            <Route path="/zone-wise-report" element={<PrivateRoute><Main element={ZoneWiseReport}/></PrivateRoute>}/>
            <Route path="/grouped-reports" element={<PrivateRoute><Main element={GroupedReports}/></PrivateRoute>}/>
            <Route path="/grouped-reports-view/:id" element={<PrivateRoute><Main element={ReportViewGroup}/></PrivateRoute>}/>
            <Route path="/edit/:id" element={<PrivateRoute><Main element={ReportEdit}/></PrivateRoute>}/>
            <Route path="/approval-pending-reports" element={<PrivateRoute><Main element={ApprovalPendingReports}/></PrivateRoute>}/>
            <Route path="/waiting-for-approval/:id" element={<PrivateRoute><Main element={WaitingForApprovalEdit}/></PrivateRoute>}/>
            <Route path="/category" element={<PrivateRoute><Main element={Category}/></PrivateRoute>}/>
            <Route path="/sub-category" element={<PrivateRoute><Main element={SubCategory}/></PrivateRoute>}/>
            {/* <Route path="/test" element={<PrivateRoute><Main element={Test}/></PrivateRoute>}/> */}
        </Routes>
      </Router>
    </>
  );
}


export default App;
